import React, { useState } from "react";
import styles from "./SelectFilter.module.scss";
import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { IUser } from "../../models/user.model";
import { Value } from 'sass';

interface Props {
    items: IUser[];
    value: any;
    readOnly: boolean;
    placeholder?: string;
    disabled?: boolean;
    search: (id: string) => void;
    label: string;
}

const SelectFilter: React.FC<Props> = ({
    items,
    value,
    readOnly,
    disabled,
    search,
    label
}) => {
    const handleChange = (email: string) => {
        search(email)
    };

    return (
        <div>
            <Select
                labelId="label"
                id="simple-select"
                label={label}
                value={value}
                size="small"
                disabled={disabled}
                readOnly={readOnly}
                className={styles.whidt40}
                onChange={(e) => {
                    let criteria = e.target.value as string;
                    handleChange(criteria);
                  }}
                
            >
                {items?.map((item) => (
                    <MenuItem key={item.email} value={item.email}>
                        {item.displayName}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
}


export default SelectFilter;